import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  powerBi: {
    marginTop: "25px",
    width: "100%",
    height: "800px"
  },

});

export default styles;
